import React, { useRef, useState, useEffect } from 'react';
import { ChevronRight, ChevronLeft } from 'lucide-react';
import ContentCard from './ContentCard';

export default function ContentRow({ title, items, className = '', children, testId, action }) {
  const ref = useRef(null);
  const [canLeft, setCanLeft] = useState(false);
  const [canRight, setCanRight] = useState(true);

  const update = () => {
    const el = ref.current; if (!el) return;
    setCanLeft(el.scrollLeft > 4);
    setCanRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 4);
  };
  useEffect(() => { update(); const el = ref.current; if (!el) return; el.addEventListener('scroll', update); window.addEventListener('resize', update); return () => { el.removeEventListener('scroll', update); window.removeEventListener('resize', update); }; }, [items]);

  const scroll = (dir) => { const el = ref.current; if (!el) return; el.scrollBy({ left: dir * (el.clientWidth - 60), behavior: 'smooth' }); };

  if (!items?.length && !children) return null;
  return (
    <section className={`pl-[22px] lg:pl-[22px] pr-0 mt-[6px] ${className}`} data-testid={testId}>
      <div className="flex items-center justify-between pr-[40px] mb-[11px]">
        <h2 className="row-title">{title}</h2>
        {action}
      </div>
      <div className="relative -ml-[22px] pl-[22px]">
        <div ref={ref} className="flex gap-[12px] overflow-x-auto no-scrollbar pr-[40px] pl-5 -ml-5 py-5 -my-5" style={{ scrollSnapType: 'x proximity' }}>
          {children || items.map((it) => <ContentCard key={it.id} item={it} />)}
        </div>
        {canLeft && <button className="row-arrow left" onClick={() => scroll(-1)} aria-label="Scroll left"><ChevronLeft size={26} /></button>}
        {canRight && <button className="row-arrow right" onClick={() => scroll(1)} aria-label="Scroll right" data-testid={`${testId || 'row'}-next`}><ChevronRight size={26} /></button>}
      </div>
    </section>
  );
}
